const state = {
  filters: {
    status: {
      toDo: true,
      requested: true,
      inProgress: true,
      done: false
    },
    datetimeFrom: null,
    datetimeTo: null,
    parentEvent: null
  }
}

const getters = {
  getFilters (state) {
    return state.filters
  }
}

const mutations = {
  setFilters (state, filters) {
    state.filters = filters
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
